module.exports = function (v) {
  return Object.prototype.toString.call(v) === '[object Array]';
};



/*****************
 ** WEBPACK FOOTER
 ** ./packages/cssx/src/helpers/isArray.js
 ** module id = 7
 ** module chunks = 0
 **/